export const Arrow = () => {
  return (
<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="22.0002" cy="22" r="21.5" fill="#FAA457" stroke="#FAA457"/>
<rect x="9.30023" y="9.2998" width="25.4" height="25.4" fill="#FAA457"/>
<rect x="9.30023" y="9.2998" width="25.4" height="25.4" stroke="#FAA457"/>
<path d="M17.6002 26.3996L26.4002 17.5996" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M19.8002 17.5996H26.4002V24.1996" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
  )
}

